import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LayoutDashboard, FileText, Settings, LogOut, Home, Sparkles, Image, BarChart3, Shield, PieChart } from 'lucide-react';
import api from '@/utils/api';

const AdminLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try { await api.post('/auth/logout'); } catch (e) { /* Session ggf. bereits abgelaufen */ }
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/analytics', label: 'Analytics', icon: PieChart },
    { path: '/admin/tracking', label: 'Tracking', icon: BarChart3 },
    { path: '/admin/ai-leads', label: 'AI-Chat Leads', icon: Sparkles },
    { path: '/admin/gallery', label: 'Galerie', icon: Image },
    { path: '/admin/content', label: 'Inhalte', icon: FileText },
    { path: '/admin/settings', label: 'Einstellungen', icon: Settings },
    { path: '/admin/security', label: 'Sicherheit', icon: Shield },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-56 bg-[#4A331D] text-white flex flex-col fixed h-full z-50">
        <div className="p-4 border-b border-white/10">
          <h2 className="font-bold text-lg text-[#D4AA6A]">BEKAJ BAU</h2>
          <p className="text-xs text-white/60">Admin Panel</p>
        </div>
        <nav className="flex-1 py-4">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${
                  active ? 'bg-white/15 text-[#D4AA6A]' : 'text-white/70 hover:bg-white/10 hover:text-white'
                }`}
                data-testid={`nav-${item.path.split('/').pop()}`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </button>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <button
            onClick={() => navigate('/')}
            className="w-full flex items-center gap-3 px-3 py-2 text-sm text-white/60 hover:text-white transition-colors"
          >
            <Home className="w-4 h-4" />
            Zur Webseite
          </button>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2 text-sm text-white/60 hover:text-red-300 transition-colors"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" />
            Abmelden
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-56 p-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-2xl font-bold text-[#4A331D] mb-6" data-testid="admin-page-title">{title}</h1>
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
